export default __webpack_public_path__ + "static/media/information-outline.72a4e6d0.svg";